import { MessageSquare } from "lucide-react";
import { trackWhatsappClick } from "@/lib/analytics";
import { buildChatWhatsappMessage } from "@/lib/chat-whatsapp";
import { buildWhatsappLink } from "@/lib/constants";

const ChatWidget = () => {
  return (
    <a
      data-testid="chat-toggle"
      aria-label="Abrir conversa no WhatsApp"
      href={buildWhatsappLink(buildChatWhatsappMessage(""), "bezierbot")}
      onClick={() => trackWhatsappClick("chat_widget")}
      target="_blank"
      rel="noreferrer"
      className="hidden sm:flex fixed bottom-6 right-6 z-[60] w-16 h-16 bg-[#ff6b35] brutal-border-thick brutal-shadow items-center justify-center hover:translate-y-[-4px] hover:translate-x-[-4px] transition-transform"
    >
      <MessageSquare size={26} className="text-[#0a0a0a]" />
    </a>
  );
};

export default ChatWidget;
